import { useQuery } from "react-query";
import api, {apiV2} from "../../api/axiosConfig";
import { Client } from "../../types/userManagement";

export const fetchClient = async (id: string): Promise<Client | null> => {
  if (!id) {
    return new Promise(() => null)
  }
  const response = await apiV2.get(`/clients/${id}`);
  return response.data;
};

export const useGetClient = (id: string) => {
  return useQuery(
    ["client", id],
    () => fetchClient(id!),
    {
      enabled: !!id, 
    }
  );
};


export const fetchClientV2 = async (id: string): Promise<Client | null> => {
    if (!id) {
        return new Promise(() => null)
    }
    const response = await apiV2.get(`/clients/${id}`);
    return response.data;
};
